import React, { useState, useEffect } from 'react';
import { H5 } from '../../../../AbstractElements';
import { Card, CardBody, CardHeader, Col, Row, FormGroup, Label, Input, Button, Alert } from 'reactstrap';
import { toast } from 'react-toastify';
import { handleAddModifyOperation } from '../../../../Api/ApiMethods';
import axios from 'axios';

const ReapplicationInformations = ({ arbitrationId, arbitrationData, refreshArbitrationData }) => {
    const [reapplicationData, setReapplicationData] = useState({
        arbitration: [],
        willReapply: false,
        willWriteExpertReport: false,
        fileCloseDescription: '',
        fileCloseDescriptionOther: '',
        comments: ''
    });

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [loading, setLoading] = useState(true);
    const [mode, setMode] = useState('add'); // 'add' or 'modify'
    const [reapplicationId, setReapplicationId] = useState(null);

    const reapplicationApiUrl = process.env.REACT_APP_LACIVERT_API_ENDPOINT + '/ReapplicationInformation';

    useEffect(() => {
        console.log('ReapplicationInformations useEffect triggered:', { arbitrationId, arbitrationData });
        if (arbitrationId && arbitrationData && typeof arbitrationData === 'object') {
            console.log('ReapplicationInformations: Calling fetchReapplicationData');
            fetchReapplicationData();
        } else {
            console.log('ReapplicationInformations: Conditions not met', { 
                hasArbitrationId: !!arbitrationId, 
                hasArbitrationData: !!arbitrationData,
                isObjectArbitrationData: typeof arbitrationData === 'object',
                arbitrationDataKeys: arbitrationData && typeof arbitrationData === 'object' ? Object.keys(arbitrationData) : []
            });
            // Eğer arbitration data henüz yüklenmemişse loading'i false yap
            if (arbitrationId && (!arbitrationData || typeof arbitrationData !== 'object')) {
                setLoading(false);
            }
        }
    }, [arbitrationId, arbitrationData]);

    const fetchReapplicationData = async () => {
        try {
            console.log('fetchReapplicationData started, arbitrationData:', arbitrationData);
            setLoading(true);
            
            // Arbitration verilerinden reapplication ID'sini al
            const reapplicationIdFromArbitration = arbitrationData && typeof arbitrationData === 'object' 
                ? arbitrationData.reapplicationInformation 
                : null;
            console.log('reapplicationIdFromArbitration:', reapplicationIdFromArbitration);
            
            if (reapplicationIdFromArbitration) {
                // Eğer reapplication ID varsa, modify modunda çalış
                setMode('modify');
                setReapplicationId(reapplicationIdFromArbitration);
                
                // ReapplicationInformation API'sinden ID ile veri çek - doğrudan axios kullan
                const token = localStorage.getItem('accessToken');
                const response = await axios.get(`${reapplicationApiUrl}/${reapplicationIdFromArbitration}`, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                });

                console.log('ReapplicationInformation API Response:', response.data);

                // API yanıtı wrapper yapısında geliyor: { isSuccess, data, message, error }
                let data = null;
                if (response.data && response.data.isSuccess && response.data.data) {
                    data = response.data.data;
                } else {
                    console.error('API response format error:', response.data);
                }

                if (data) {
                    // API'den gelen veri formatını forma uygun hale getir
                    const commentText = data.comments && Array.isArray(data.comments) && data.comments.length > 0 
                        ? data.comments[0]?.comment || ''
                        : '';

                    setReapplicationData({
                        id: data.id || null,
                        arbitration: data.arbitration || [arbitrationId],
                        willReapply: data.willReapply !== null && data.willReapply !== undefined ? data.willReapply : false,
                        willWriteExpertReport: data.willWriteExpertReport !== null && data.willWriteExpertReport !== undefined ? data.willWriteExpertReport : false,
                        fileCloseDescription: data.fileCloseDescription || '',
                        fileCloseDescriptionOther: data.fileCloseDescriptionOther || '',
                        comments: commentText
                    });
                } else {
                    console.error('Reapplication data fetch error: No data returned');
                    toast.error('Tekrar başvuru bilgileri yüklenirken hata oluştu');
                    // Hata durumunda add moduna geç
                    setMode('add');
                    setReapplicationId(null);
                    setReapplicationData({
                        arbitration: [arbitrationId],
                        willReapply: false,
                        willWriteExpertReport: false,
                        fileCloseDescription: '',
                        fileCloseDescriptionOther: '',
                        comments: ''
                    });
                }
            } else {
                // Reapplication ID yoksa, add modunda çalış
                console.log('No reapplication ID found, setting add mode');
                setMode('add');
                setReapplicationId(null);
                setReapplicationData({
                    arbitration: [arbitrationId],
                    willReapply: false,
                    willWriteExpertReport: false,
                    fileCloseDescription: '',
                    fileCloseDescriptionOther: '',
                    comments: ''
                });
            }
        } catch (error) {
            console.error('Error fetching reapplication data:', error);
            toast.error('Tekrar başvuru bilgileri yüklenirken hata oluştu');
            // Hata durumunda add moduna geç
            setMode('add');
            setReapplicationId(null);
            setReapplicationData({
                arbitration: [arbitrationId],
                willReapply: false,
                willWriteExpertReport: false,
                fileCloseDescription: '',
                fileCloseDescriptionOther: '',
                comments: ''
            });
        } finally {
            setLoading(false);
        }
    };

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        
        if (type === 'checkbox' || type === 'radio') {
            setReapplicationData(prev => ({
                ...prev,
                [name]: type === 'checkbox' ? checked : (value === 'true')
            }));
        } else {
            setReapplicationData(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        setIsSubmitting(true);
        
        try {
            // API'ye gönderilecek veriyi doğru mapping'e göre hazırla
            const apiData = {
                reapplicationInformation: {
                    arbitration: [arbitrationId],
                    willReapply: reapplicationData.willReapply,
                    willWriteExpertReport: reapplicationData.willWriteExpertReport,
                    fileCloseDescription: reapplicationData.fileCloseDescription || '', // Dosya Kapatma Yorumu
                    fileCloseDescriptionOther: reapplicationData.fileCloseDescriptionOther || '', // Manuel Dosya Kapatma Yorumu
                    comments: reapplicationData.comments ? [{
                        commentType: "Genel",
                        comment: reapplicationData.comments // Ek Yorum
                    }] : []
                },
                accidentFileCloseInformation: {
                    fileStatus: "Açık",
                    fileCloseDescription: reapplicationData.fileCloseDescription || '', // Dosya Kapatma Yorumu
                    fileCloseDescriptionOther: reapplicationData.fileCloseDescriptionOther || '', // Manuel Dosya Kapatma Yorumu
                    fileCloseComment: reapplicationData.comments || '' // Ek Yorum
                }
            };

            console.log('ReapplicationInformations: API Data being sent:', apiData);

            await handleAddModifyOperation({
                apiEndpoint: reapplicationApiUrl,
                selectedItem: mode === 'modify' ? { id: reapplicationId } : null,
                mode,
                data: apiData,
                refreshDataCallback: () => {
                    // Arbitration verilerini yenile ki reapplication ID güncellensin
                    refreshArbitrationData();
                    // Component verilerini de yenile
                    fetchReapplicationData();
                },
                componentName: 'Tekrar başvuru bilgisi'
            });

        } catch (error) {
            console.error('ReapplicationInformations: Submit error:', error);
            toast.error('Bir hata oluştu. Lütfen tekrar deneyin.');
        } finally {
            setIsSubmitting(false);
        }
    };

    if (loading) {
        return (
            <Row className="mt-4">
                <Col sm='12'>
                    <Card>
                        <CardHeader>
                            <H5>Tekrar Başvuru Bilgileri</H5>
                        </CardHeader>
                        <CardBody>
                            <div className="text-center p-4">
                                <p>Yükleniyor...</p>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        );
    }

    return (
        <Row className="mt-4">
            <Col sm='12'>
                <Card>
                    <CardHeader>
                        <H5>Tekrar Başvuru Bilgileri</H5>
                        <span>
                            {mode === 'modify' 
                                ? 'Mevcut tekrar başvuru bilgilerini düzenleyebilirsiniz.' 
                                : 'Tahkim süreci için tekrar başvuru bilgilerini girebilirsiniz.'
                            }
                        </span>
                    </CardHeader>
                    <CardBody>
                        {mode === 'modify' && (
                            <Alert color="info" className="mb-4">
                                <i className="fa fa-info-circle me-2"></i>
                                Bu tahkim için daha önce tekrar başvuru bilgisi kaydedilmiş. Aşağıdaki formdan düzenleyebilirsiniz.
                            </Alert>
                        )}

                        <form onSubmit={handleSubmit}>
                            <Row>
                                <Col md="12">
                                    <FormGroup className="mb-4">
                                        <Label className="text-nowrap mb-2">Tekrar başvuru yapılacak mı?</Label>
                                        <div className="d-flex">
                                            <div className="radio radio-primary me-3 d-flex align-items-center">
                                                <Input
                                                    name="willReapply"
                                                    type="radio"
                                                    value="true"
                                                    id="reapplyYes"
                                                    checked={reapplicationData.willReapply === true}
                                                    onChange={handleInputChange}
                                                />
                                                <Label check for="reapplyYes" className="ms-1 mb-0">Evet</Label>
                                            </div>
                                            <div className="radio radio-primary d-flex align-items-center">
                                                <Input
                                                    name="willReapply"
                                                    type="radio"
                                                    value="false"
                                                    id="reapplyNo"
                                                    checked={reapplicationData.willReapply === false}
                                                    onChange={handleInputChange}
                                                />
                                                <Label check for="reapplyNo" className="ms-1 mb-0">Hayır</Label>
                                            </div>
                                        </div>
                                    </FormGroup>
                                </Col>
                            </Row>

                            <Row>
                                <Col md="12">
                                    <FormGroup className="mb-4">
                                        <Label className="text-nowrap mb-2">Eksper raporu yazılacak mı?</Label>
                                        <div className="d-flex">
                                            <div className="radio radio-primary me-3 d-flex align-items-center">
                                                <Input
                                                    name="willWriteExpertReport"
                                                    type="radio"
                                                    value="true"
                                                    id="expertReportYes"
                                                    checked={reapplicationData.willWriteExpertReport === true}
                                                    onChange={handleInputChange}
                                                />
                                                <Label check for="expertReportYes" className="ms-1 mb-0">Evet</Label>
                                            </div>
                                            <div className="radio radio-primary d-flex align-items-center">
                                                <Input
                                                    name="willWriteExpertReport"
                                                    type="radio"
                                                    value="false"
                                                    id="expertReportNo"
                                                    checked={reapplicationData.willWriteExpertReport === false}
                                                    onChange={handleInputChange}
                                                />
                                                <Label check for="expertReportNo" className="ms-1 mb-0">Hayır</Label>
                                            </div>
                                        </div>
                                    </FormGroup>
                                </Col>
                            </Row>

                            <Row>
                                <Col md="12">
                                    <FormGroup className="mb-4">
                                        <Label for="fileCloseDescription">Dosya Kapama Açıklaması</Label>
                                        <Input
                                            type="select"
                                            name="fileCloseDescription"
                                            id="fileCloseDescription"
                                            value={reapplicationData.fileCloseDescription}
                                            onChange={handleInputChange}
                                        >
                                            <option value="">Dosya kapama sebebini seçin...</option>
                                            <option value="Sulh Anlaşması Nedeniyle">Sulh Anlaşması Nedeniyle</option>
                                            <option value="Eksper İncelemesi Sonucu Aracın Hasar Tutarının Eksik Olduğu Kanaatine Varıldığı">Eksper İncelemesi Sonucu Aracın Hasar Tutarının Eksik Olduğu Kanaatine Varıldığı</option>
                                            <option value="Sigortalı/Zarar Gören Tarafından İstenmediği">Sigortalı/Zarar Gören Tarafından İstenmediği</option>
                                            <option value="Sigortalının/Zarar Görenin Ulaşılamaması">Sigortalının/Zarar Görenin Ulaşılamaması</option>
                                            <option value="Eksper Raporu Alınıp İnceleme Yapıldıktan Sonra Dosyanın Gereksiz Olduğu Tespit Edildiği">Eksper Raporu Alınıp İnceleme Yapıldıktan Sonra Dosyanın Gereksiz Olduğu Tespit Edildiği</option>
                                            <option value="Başvurunun Yasal Süresi Geçtiği">Başvurunun Yasal Süresi Geçtiği</option>
                                            <option value="Maddi Hasarı Bulunmadığı">Maddi Hasarı Bulunmadığı</option>
                                            <option value="Yaralanma Söz Konusu Olmadığı">Yaralanma Söz Konusu Olmadığı</option>
                                            <option value="Dosyada Hukuki Problem Olduğu">Dosyada Hukuki Problem Olduğu</option>
                                            <option value="Evrakların Eksik/Hatalı Olduğu">Evrakların Eksik/Hatalı Olduğu</option>
                                            <option value="Sigortalı Aleyhine Haksızlık Olmadığı">Sigortalı Aleyhine Haksızlık Olmadığı</option>
                                            <option value="Objektif Kusur Değerlendirmesi">Objektif Kusur Değerlendirmesi</option>
                                            <option value="Başka Şirkete Dosya Açıldığı">Başka Şirkete Dosya Açıldığı</option>
                                            <option value="Mükerrer/Devam Dosyası Olduğu">Mükerrer/Devam Dosyası Olduğu</option>
                                            <option value="Ticari Araç Başvurusu Olduğu">Ticari Araç Başvurusu Olduğu</option>
                                            <option value="Basit Onarım İşi Olduğu">Basit Onarım İşi Olduğu</option>
                                            <option value="Başvurudan Vazgeçildiği">Başvurudan Vazgeçildiği</option>
                                            <option value="MEAEM Görevi Dışı Olduğu">MEAEM Görevi Dışı Olduğu</option>
                                            <option value="Bilgi Edinme Başvurusu Olduğu">Bilgi Edinme Başvurusu Olduğu</option>
                                            <option value="Ceza Avukatı Tutulduğu İçin Takip Edilmeyeceği">Ceza Avukatı Tutulduğu İçin Takip Edilmeyeceği</option>
                                            <option value="İcra Takibinin Başlatıldığı">İcra Takibinin Başlatıldığı</option>
                                            <option value="Dava Açıldığı">Dava Açıldığı</option>
                                            <option value="Şikayetin Geri Çekildiği">Şikayetin Geri Çekildiği</option>
                                            <option value="Diğer">Diğer</option>
                                        </Input>
                                    </FormGroup>
                                </Col>
                            </Row>

                            {reapplicationData.fileCloseDescription === "Diğer" && (
                                <Row>
                                    <Col md="12">
                                        <FormGroup className="mb-4">
                                            <Label for="fileCloseDescriptionOther">Diğer Açıklama</Label>
                                            <Input
                                                type="textarea"
                                                name="fileCloseDescriptionOther"
                                                id="fileCloseDescriptionOther"
                                                rows="3"
                                                value={reapplicationData.fileCloseDescriptionOther}
                                                onChange={handleInputChange}
                                                placeholder="Lütfen dosya kapama sebebini açıklayın..."
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            )}

                            <Row>
                                <Col md="12">
                                    <FormGroup className="mb-4">
                                        <Label for="comments">Yorum</Label>
                                        <Input
                                            type="textarea"
                                            name="comments"
                                            id="comments"
                                            rows="4"
                                            value={reapplicationData.comments}
                                            onChange={handleInputChange}
                                            placeholder="Tekrar başvuru ile ilgili yorumlarınızı giriniz..."
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>

                            <Row>
                                <Col md="12" className="text-end">
                                    <Button 
                                        color="primary" 
                                        type="submit" 
                                        disabled={isSubmitting}
                                        size="lg"
                                    >
                                        {isSubmitting ? 'Kaydediliyor...' : (mode === 'add' ? 'Kaydet' : 'Güncelle')}
                                    </Button>
                                </Col>
                            </Row>
                        </form>
                    </CardBody>
                </Card>
            </Col>
        </Row>
    );
};

export default ReapplicationInformations;
